import { isLast } from "@punks/core"
import React from "react"
import { ProductVariant } from "../../../../../../types/product"
import Stroke from "../../../../../../ui/atoms/Stroke"
import { Basket, BasketItem } from "../../../../state/checkoutTypes"

import BasketItemListElement from "../BasketItemListElement"

interface Props {
  basket: Basket
  onProductRemove: (item: BasketItem) => void
  onProductMoveToWishlist: (item: BasketItem) => void
  onProductVariantChange: (item: BasketItem, newVariant: ProductVariant) => void
  onProductQuantityChange: (item: BasketItem, newQuantity: number) => void
  onProductGiftToggle: (item: BasketItem, newValue: boolean) => void
}

const BasketItemsList = ({
  basket,
  onProductRemove,
  onProductMoveToWishlist,
  onProductVariantChange,
  onProductQuantityChange,
  onProductGiftToggle,
}: Props) => {
  const [viewAll] = React.useState(true)
  const basketItems = viewAll ? basket.items : basket.items.slice(0, 4)
  return (
    <>
      {basketItems.map((item, index) => (
        <div key={index} className="my-4">
          <BasketItemListElement
            giftBoxEnabled={basket.settings.giftBoxEnabled}
            item={item}
            onProductRemove={() => onProductRemove(item)}
            onProductMoveToWishlist={() => onProductMoveToWishlist(item)}
            onProductVariantChange={(newVariant) =>
              onProductVariantChange(item, newVariant)
            }
            onProductQuantityChange={(newQuantity) =>
              onProductQuantityChange(item, newQuantity)
            }
            onProductGiftToggle={(newValue) =>
              onProductGiftToggle(item, newValue)
            }
          />
          {!isLast(index, basket.items) && (
            <Stroke className="my-4" color="disabled" />
          )}
        </div>
      ))}
      {/* <CustomBox textCenter>
        <CustomButton variant="text" onClick={() => setViewAll(!viewAll)}>
          {viewAll ? "Vedi meno" : "Vedi tutti"}
        </CustomButton>
      </CustomBox> */}
    </>
  )
}

export default BasketItemsList
